function hideFromMarket() {
/*
MODIFICATION IS PROVIDED BY THE SEARCHANISE TEAM, WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

This modification hides specified collections and pages from the Australian market.
Collections and pages are specified by their title, it is case-insesitive. 

Specify the list of the collections in the hideCollectionsFromAu variable and the list of the pages in the hidePagesFromAu variable.  
The list should start and end with a square bracket. Each collection/page should be enclosed in the pair of quote marks. All collections/pages should be separated by a comma. Here is an example of what it should look like: 

    let hideCollectionsFromAu = ['collection one', 'collection two'];

If you need to disable the modification, you can change the value of the isEnabled variable from true to false:
    
    let isEnabled = false;
*/

// SETTINGS

let isEnabled = true;

let hideCollectionsFromAu = ["Solar Panel", "110W 160W 200W 400W Solar Panel Gifts","EcoFlow GLACIER", "EcoFlow Portable Power Station", "EcoFlow RIVER Series Power Supply Combo", "Smart Generator"];

let hidePagesFromAu = ["EcoFlow DELTA Pro 3 vs Anker SOLIX F3800"];

// SETTINGS END. DO NOT MODIFY THE CODE BELOW.

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

        if (!isEnabled || isEnabled == 'false') { return }

        $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
            if (data && Shopify.country && Shopify.country == 'AU') {
                if (data.categories && data.categories.length) {
                    data.categories = data.categories.filter(function(item) {
                        for (let title of hideCollectionsFromAu) {
                            if (item.title.toLowerCase() == title.toLowerCase()) {
                                return false;
                            }
                        }
                        return true;
                    });
                }
                if (data.pages && data.pages.length) {
                    data.pages = data.pages.filter(function(item) {
                        for (let title of hidePagesFromAu) {
                            if (item.title.toLowerCase() == title.toLowerCase()) {
                                return false;
                            }
                        }
                        return true;
                    });
                }
            }
        });
    })(window.Searchanise.$);
});
};
hideFromMarket();